import { clsx } from 'clsx';
import CountryFlagSvg from 'country-list-with-dial-code-and-flag/dist/flag-svg';

import { IFlagProps } from '@/ui-kit/flag/Flag.types';

export function Flag({ country, className }: IFlagProps) {
  return (
    <img
      className={clsx('w-[13.33px] h-[10.67px] rounded-[3px] my-auto', className)}
      src={`data:image/svg+xml;utf8,${encodeURIComponent(CountryFlagSvg[country])}`}
      alt={country.toString()}
    />
  );
}
